export default __webpack_public_path__ + "static/media/leo.a95be329.png";